document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');
if (header) {
  const toggle = header.querySelector('[data-menu-toggle]');
  const mobile = header.querySelector('[data-mobile-nav]');
  const updateHeader = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
    if (mobile) mobile.style.top = `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`;
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader, { passive: true });
  if (toggle && mobile) toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    mobile.hidden = expanded;
    document.body.classList.toggle('menu-open', !expanded);
  });
}

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const json = root.querySelector('[data-product-variants]');
  const form = root.querySelector('.product-form');
  if (!json || !form) return;

  let variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }

  const hidden = form.querySelector('[data-variant-id]');
  const button = form.querySelector('[data-add-to-cart]');
  const optionGroups = [...form.querySelectorAll('[data-option-index]')];
  const isSoleaBundle = root.hasAttribute('data-solea-bundle-root');
  const money = (cents) => new Intl.NumberFormat(
    document.documentElement.lang || 'en-AU',
    { style: 'currency', currency: window.Shopify?.currency?.active || 'AUD' }
  ).format(cents / 100);

  if (!hidden || !button) return;

  const update = () => {
    let variant = null;

    if (optionGroups.length) {
      const selected = optionGroups.map(group => group.querySelector('input:checked')?.value);
      variant = variants.find(candidate => candidate.options.every((option, index) => option === selected[index]));
    } else {
      variant = variants.find(candidate => String(candidate.id) === String(hidden.value)) || variants[0];
    }

    if (!variant) {
      button.disabled = true;
      button.dataset.originalDisabled = 'true';
      return;
    }

    hidden.value = variant.id;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);

    button.disabled = !variant.available;
    button.dataset.originalDisabled = variant.available ? 'false' : 'true';

    /*
      SOLEA1 has its own bundle-price and add-on UI. Do not replace the
      button's innerHTML here: doing so removes the price target used by
      the bundle script. Only update its dedicated elements.
    */
    if (isSoleaBundle) {
      const label = button.querySelector('[data-solea-button-label]');
      const priceWrap = button.querySelector('[data-solea-button-price-wrap]');
      const price = button.querySelector('[data-solea-button-price]');
      const preorder = button.dataset.soleaPreorder === 'true';

      if (label) {
        label.textContent = variant.available
          ? 'Add to bag'
          : 'Sold out';
      }

      if (priceWrap) priceWrap.hidden = !variant.available;
      if (price) price.textContent = money(variant.price);
      return;
    }

    button.textContent = variant.available
      ? `Add to bag — ${money(variant.price)}`
      : 'Sold out';
  };

  /*
    IMPORTANT: only actual main-product option controls should trigger a
    variant recalculation. Add-on checkboxes, quantity fields, etc. must
    not be interpreted as product-option changes.
  */
  optionGroups.forEach(group => {
    group.querySelectorAll('input').forEach(input => {
      input.addEventListener('change', update);
    });
  });
});

